































































































import {Component, Vue} from 'vue-property-decorator';
import {mapFields} from 'vuex-map-fields';

/**
 * Partition display item component,
 * includes a button for expanding/collapsing contained items
 */
@Component({
    props: {
        /**
         * Is the partition currently in expanded state
         */
        expanded: {
            type: Boolean
        },
        expandable: {
            type: Boolean,
            default: true
        },
        topFirst: {
            type: Boolean
        }
    },
    computed: mapFields('settings', [
        'show_timestamps',
        'show_media'
    ])
})
export default class DisplayItemPartition extends Vue {

    private formatTimestamp(timestamp: string) {

        // Remove date
        timestamp = timestamp.split(' ')[1];

        // Remove millis
        timestamp = timestamp.split('.')[0];

        return timestamp;
    }
}
